<article class="c-resource-details c-resource-details__article">
  <ng-container>
    <img
      alt=""
      class="c-resource-details__thumbnail is-expanded disabled"
      [src]="resourceImageUrl"
    />
  </ng-container>

  <div class="c-resource-details__content">
    <div class="c-resource-details__content--info">
      <header class="c-resource-details__meta">
        <rl-fielded-resource [resource]="bibliographicResource">
        </rl-fielded-resource>
      </header>
      <rl-online-resource-button
        *ngIf="onlineResource"
        class="u-mr2"
        [onlineResource]="onlineResource"
      >
      </rl-online-resource-button>
    </div>

    <div class="row c-resource-details__detail">
      <section class="c-resource-details__availability col-xs-12">
        <div class="row">
          <rl-resource-availability
            [resource]="bibliographicResource"
            class="col-xs-12 col-md-6 u-flex-fix"
          >
          </rl-resource-availability>
          <rl-item-metadata
            [resource]="bibliographicResource"
            class="col-xs-12 col-md-6 u-flex-fix"
          >
          </rl-item-metadata>
        </div>
      </section>
    </div>
  </div>
</article>
